import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, useApp } from "@/context/AppContext";
import { money, formatDate, thumb } from "@/lib/helpers";
import { Layers, ArrowRight } from "lucide-react";

export const BundlesSection = () => {
  const { lang } = useApp();
  const [bundles, setBundles] = useState([]);

  useEffect(() => {
    api.get("/bundles").then((r) => setBundles(r.data.bundles)).catch(() => {});
  }, []);

  if (!bundles.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20" data-testid="bundles-section">
      <p className="text-[11px] uppercase tracking-widest text-[#D94E28] flex items-center gap-1.5">
        <Layers className="h-3.5 w-3.5" />{lang === "es" ? "Paquetes con descuento" : "Discounted packages"}
      </p>
      <h2 className="mt-3 font-heading uppercase text-3xl sm:text-4xl text-[#16221D] leading-none">
        {lang === "es" ? "Varias cumbres, un solo pago" : "Several summits, one payment"}
      </h2>
      <p className="mt-2 text-[#5E6D64] text-sm md:text-base">
        {lang === "es" ? "Fechas ya combinadas por nuestro equipo a precio especial."
          : "Dates curated by our team at a special price."}
      </p>

      <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {bundles.map((b, i) => (
          <Link key={b.bundle_id} to={`/paquete?bundle=${b.bundle_id}`}
            data-testid={`bundle-card-${b.bundle_id}`}
            style={{ animationDelay: `${i * 70}ms` }}
            className="group block rounded-2xl bg-white border border-[#E2DFD7] overflow-hidden hover:-translate-y-1 hover:shadow-[0_16px_44px_rgb(0,0,0,0.12)] transition-transform duration-300 animate-rise">
            <div className="relative h-44 overflow-hidden">
              <img src={thumb(b.hero_image || b.items[0]?.hero_image, 640)} alt={b.name} loading="lazy" decoding="async"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              {b.savings > 0 && (
                <span className="absolute top-3 left-3 rounded-full bg-[#D94E28] text-white text-xs font-semibold px-3 py-1"
                  data-testid={`bundle-savings-${b.bundle_id}`}>
                  {lang === "es" ? "Ahorras" : "Save"} {money(b.savings)}
                </span>
              )}
            </div>
            <div className="p-5">
              <h3 className="text-xl font-semibold text-[#16221D] leading-snug">{b.name}</h3>
              <ul className="mt-3 space-y-1 text-xs text-[#5E6D64]">
                {b.items.map((it) => (
                  <li key={it.departure_id} className="capitalize truncate">
                    {formatDate(it.date, lang)} · {it.route_name}
                  </li>
                ))}
              </ul>
              <div className="mt-5 flex items-end justify-between">
                <div>
                  {b.savings > 0 && (
                    <p className="text-xs text-[#8A968E] line-through">{money(b.list_price)}</p>
                  )}
                  <p className="text-2xl font-bold text-[#16221D]">{money(b.price)}
                    <span className="text-[10px] align-super text-[#8A968E]"> MXN</span></p>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-[#6E7E56] text-white text-sm px-5 py-2 group-hover:bg-[#D94E28] transition-colors duration-300">
                  {lang === "es" ? "Ver paquete" : "See package"} <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
